export default __webpack_public_path__ + "static/media/logoLogin.eaed05df.png";